var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags-cell-renderer"},[(_vm.tags.length)?_c('TagsContainer',{attrs:{"tags":_vm.showTags,"isReadonly":true,"hiddenTags":_vm.tags.length - _vm.showTags.length}}):[_vm._v(_vm._s(_vm.EmptyTableCell))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }